import * as React from 'react'
import { styled as muiStyled } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import { Title } from 'components/atomic/standalone/molecules/Title'

type Props = {
  size?: 'small' | 'large'
  title: string
  description: string
}
export const Info: React.FC<Props> = ({
  size = 'medium',
  title,
  description,
}) => {
  let variant: 'body1' | 'body2' = 'body1'
  if (size == 'small') variant = 'body2'

  return (
    <Detail>
      <Title size="medium" title={title} />

      <Text variant={variant} color="textPrimary">
        {description}
      </Text>
    </Detail>
  )
}

const Detail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`

const Text = muiStyled(Typography)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  margin: '20px 0',
  lineHeight: '180%',
  whiteSpace: 'pre-line',
  textAlign: 'center',
})
